import { render, staticRenderFns } from "./ProposalDialogSignature.vue?vue&type=template&id=ae0e6d9c&scoped=true"
import script from "./ProposalDialogSignature.vue?vue&type=script&lang=js"
export * from "./ProposalDialogSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0e6d9c",
  null
  
)

export default component.exports